import { render, staticRenderFns } from "./VDatePicker.vue?vue&type=template&id=32b2747c&"
import script from "./VDatePicker.vue?vue&type=script&lang=js&"
export * from "./VDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports